module.exports = __webpack_public_path__ + "img/left-side-menu-scenario-settings-active.dcfce37c.svg";